// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"385":"a87f9e1d","392":"7b6c44a7","953":"6abb9526"}[chunkId] + ".css";
};